module.exports = __webpack_public_path__ + "static/ppp-chapter-sample-display.57ccc300.png";